import { forwardRef, type FC } from 'react';

import styles from './MarcaDaNyta.module.scss';

// A MARCA DA NYTA É O "IA" DO CARBON (pedido do Lucas, 27/09/2026): onde a Nyta aparece, aparece o
// rótulo de IA do sistema, e não mais a estrela. É o desenho do `AILabel` do Carbon (a caixa de 1px
// com "IA" em 600), em SVG para servir de avatar e de ícone de botão. As medidas são as do Carbon:
// no tamanho de ícone, o `mini` (caixa de 16, texto de 9); no de avatar, o `xs` (caixa de 24, texto
// de 12). A borda fica em 1px em qualquer tamanho.
//
// O rótulo interativo (o que abre a explicação "Como a Nyta gerou isto") continua sendo o
// `RotuloDeIA`, no cabeçalho da conversa e em cada resposta; esta é a marca parada.
//
// `pensando` pulsa devagar (e fica parada para quem pediu menos movimento).

const Caixa: FC<{ lado: number; fonte: number }> = ({ lado, fonte }) => (
  <>
    <rect x={0.5} y={0.5} width={lado - 1} height={lado - 1} fill='none' stroke='currentColor' strokeWidth={1} vectorEffect='non-scaling-stroke' />
    <text x={lado / 2} y={lado / 2} textAnchor='middle' dominantBaseline='central' fontSize={fonte} fontWeight={600} fill='currentColor'>IA</text>
  </>
);

export const MarcaDaNyta: FC<{ pensando?: boolean; className?: string }> = ({ pensando, className }) => (
  <svg viewBox='0 0 24 24' className={[styles.marca, pensando ? styles.pensando : '', className].filter(Boolean).join(' ')} aria-hidden focusable='false'>
    <Caixa lado={24} fonte={12} />
  </svg>
);

/**
 * A mesma marca como ÍCONE do Carbon (o `renderIcon` de um botão, o ícone de uma ação do topo):
 * recebe o `size` como os ícones de `@carbon/icons-react`, com as proporções do `AILabel` mini.
 */
export const IconeDaNyta = forwardRef<SVGSVGElement, { size?: number | string; className?: string }>(({ size = 16, className, ...resto }, ref) => (
  <svg ref={ref} viewBox='0 0 16 16' width={size} height={size} className={[styles.icone, className].filter(Boolean).join(' ')} aria-hidden focusable='false' {...resto}>
    <Caixa lado={16} fonte={9} />
  </svg>
));
IconeDaNyta.displayName = 'IconeDaNyta';
